import { Controller } from "@hotwired/stimulus"

const PAUSE = 2000

// Shows the presentation controls while the pointer moves, and fades them after a pause
// unless the pointer is resting on one. The component's classes do the showing.
export default class extends Controller {
  static targets = ["fullscreen"]

  connect() {
    this.fullscreenTarget.hidden = !document.fullscreenEnabled
    this.wake()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  wake() {
    this.element.toggleAttribute("data-active", true)
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.rest(), PAUSE)
  }

  rest() {
    if (this.element.querySelector(":hover")) return this.wake()

    this.element.removeAttribute("data-active")
  }

  // The whole page, not just the deck: menus, tooltips and modals opened from a slide
  // live outside it, and the browser shows nothing outside the fullscreen element.
  toggleFullscreen() {
    document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen()
  }
}
